export const DownloadWithLoadingState = {
  mounted() {
    this.handleClick = this.handleClick.bind(this)
    this.el.addEventListener("click", this.handleClick)
  },

  destroyed() {
    this.el.removeEventListener("click", this.handleClick)
  },

  handleClick(e) {
    e.preventDefault()

    if (this.el.disabled) {
      return
    }

    const url = this.el.dataset.downloadUrl
    const filename = this.el.dataset.downloadName
    const loadingText = this.el.dataset.loadingText || "Loading..."
    const labelEl = this.el.querySelector("[data-label]")
    const originalText = labelEl ? labelEl.textContent : null

    if (!url || url === "#") {
      console.error("DownloadWithLoadingState: No valid download-url specified")
      return
    }

    // Set loading state
    this.el.disabled = true
    if (labelEl) {
      labelEl.textContent = loadingText
    }

    // Fetch the file
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.blob()
      })
      .then((blob) => {
        // Create blob URL and trigger download
        const blobUrl = window.URL.createObjectURL(blob)
        const anchor = document.createElement("a")
        anchor.style.display = "none"
        anchor.href = blobUrl
        anchor.download = filename
        document.body.appendChild(anchor)
        anchor.click()

        // Cleanup
        window.URL.revokeObjectURL(blobUrl)
        document.body.removeChild(anchor)

        // Restore button state
        this.el.disabled = false
        if (labelEl && originalText) {
          labelEl.textContent = originalText
        }
      })
      .catch((error) => {
        console.error("Download failed:", error)

        // Restore button state on error
        this.el.disabled = false
        if (labelEl && originalText) {
          labelEl.textContent = originalText
        }
      })
  },
}
